import SingleSelectFullWidthCode from "!!raw-loader!./autocomplete/SingleSelectFullWidth.tsx";
import SingleSelectWithTabsCode from "!!raw-loader!./autocomplete/SingleSelectWithTabs";
import SingleSelectOverflowCode from "!!raw-loader!./autocomplete/SingleSelectOverflow.tsx";
import SingleSelectPlaceholderCode from "!!raw-loader!./autocomplete/SingleSelectPlaceholder.tsx";
import SingleSelectHelperTextCode from "!!raw-loader!./autocomplete/SingleSelectHelperText.tsx";
import SingleSelectReactWindowCode from "!!raw-loader!./autocomplete/SingleSelectReactWindow.tsx";
import SingleSelectRequiredCode from "!!raw-loader!./autocomplete/SingleSelectRequired.tsx";
import SingleSelectDisabledCode from "!!raw-loader!./autocomplete/SingleSelectDisabled.tsx";
import SingleSelectGroupingCode from "!!raw-loader!./autocomplete/SingleSelectGrouping.tsx";
import SingleSelectBottomContentsCode from "!!raw-loader!./autocomplete/SingleSelectBottomContents.tsx";
import SingleSelectInvalidCode from "!!raw-loader!./autocomplete/SingleSelectInvalid.tsx";
import SingleSelectCustomOptionsCode from "!!raw-loader!./autocomplete/SingleSelectCustomOptions.tsx";
import SingleSelectSlimCardCode from "!!raw-loader!./autocomplete/SingleSelectSlimCard.tsx";
import DataGridSingleSelectCode from "!!raw-loader!./datagrids/DataGridSingleSelect.tsx";
import SingleSelectPinyinFilteringCode from "!!raw-loader!./autocomplete/SingleSelectPinyinFiltering.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import SingleSelectFullWidth from "./autocomplete/SingleSelectFullWidth";
import SingleSelectWithTabs from "./autocomplete/SingleSelectWithTabs";
import SingleSelectOverflow from "./autocomplete/SingleSelectOverflow";
import SingleSelectPlaceholder from "./autocomplete/SingleSelectPlaceholder";
import SingleSelectHelperText from "./autocomplete/SingleSelectHelperText";
import SingleSelectReactWindow from "./autocomplete/SingleSelectReactWindow";
import SingleSelectRequired from "./autocomplete/SingleSelectRequired";
import SingleSelectDisabled from "./autocomplete/SingleSelectDisabled";
import SingleSelectGrouping from "./autocomplete/SingleSelectGrouping";
import SingleSelectBottomContents from "./autocomplete/SingleSelectBottomContents";
import SingleSelectInvalid from "./autocomplete/SingleSelectInvalid";
import SingleSelectCustomOptions from "./autocomplete/SingleSelectCustomOptions";
import SingleSelectSlimCard from "./autocomplete/SingleSelectSlimCard";
import DataGridSingleSelect from "./datagrids/DataGridSingleSelect";
import SingleSelectPinyinFiltering from "./autocomplete/SingleSelectPinyinFiltering";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("ReactWindow", SingleSelectReactWindowCode, SingleSelectReactWindow, "Use React Window render options"),
		paneComponent("FullWidth", SingleSelectFullWidthCode, SingleSelectFullWidth, "It would take up the full width of the parent by default, specify the width to change this behavior"),
		paneComponent("Overflow", SingleSelectOverflowCode, SingleSelectOverflow),
		paneComponent("Placeholder", SingleSelectPlaceholderCode, SingleSelectPlaceholder),
		paneComponent("Required", SingleSelectRequiredCode, SingleSelectRequired),
		paneComponent("DataGrid SingleSelect", DataGridSingleSelectCode, DataGridSingleSelect),
		paneComponent("SingleSelect w/ tabs", SingleSelectWithTabsCode, SingleSelectWithTabs),
		paneComponent("Disabled items", SingleSelectDisabledCode, SingleSelectDisabled),
		paneComponent("Invalid Items", SingleSelectInvalidCode, SingleSelectInvalid),
		paneComponent("Grouping", SingleSelectGroupingCode, SingleSelectGrouping),
		paneComponent("Actions menu", SingleSelectBottomContentsCode, SingleSelectBottomContents),
		paneComponent("Custom options", SingleSelectCustomOptionsCode, SingleSelectCustomOptions),
		paneComponent("Helper Text", SingleSelectHelperTextCode, SingleSelectHelperText),
		paneComponent("SlimCard", SingleSelectSlimCardCode, SingleSelectSlimCard, "Use slim card to render option"),
		paneComponent("Pinyin Filtering", SingleSelectPinyinFilteringCode, SingleSelectPinyinFiltering, "Use Pinyin code to filter out items"),
	];

	return (
		<Pane
			components={components}
			imports={"import {SingleSelect} from \"designSystem/index\";"}
			muiApi="autocomplete"
			muiComponent="autocomplete"
			{...props}
		/>
	);
};